
import { put, takeEvery } from 'redux-saga/effects';

import {
  AGREEMENTS_REGULATIONS_CHANGE,
  accountFormRegulationsSet,
  accountFormRegulationsSetValidationMessage
} from 'src/app/redux/actions/registration/account/accountFormAgreementsRegulations';


function* accountFormAgreementsRegulationsChange({ payload }) {
  const { checked, validationMessage } = payload;

  yield put(accountFormRegulationsSet(checked));
  yield put(accountFormRegulationsSetValidationMessage(validationMessage));
}


export {  accountFormAgreementsRegulationsChange };

export default [
  takeEvery(AGREEMENTS_REGULATIONS_CHANGE, accountFormAgreementsRegulationsChange)
];

